const theme = {
  colors: {
    primary: '#2563eb',
    secondary: '#5B3DF5',
    tertiary: '#21C6F7',
    text: '#FFFFFF',
    background: '#121212',
    darkBackground: '#0A0A0A',
    lightBackground: '#1E1E1E',
    gray: '#888888',
    success: '#4BB543',
    error: '#2563eb'
  },
  fonts: {
    heading: "'Montserrat', sans-serif",
    body: "'Poppins', sans-serif"
  },
  breakpoints: {
    xs: '576px',
    sm: '768px',
    md: '992px',
    lg: '1200px'
  },
  transition: {
    standard: 'all 0.3s ease'
  },
  shadows: {
    small: '0 2px 10px rgba(0, 0, 0, 0.2)',
    medium: '0 5px 15px rgba(0, 0, 0, 0.3)',
    large: '0 10px 25px rgba(0, 0, 0, 0.4)'
  },
  gradients: {
    primary: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
    secondary: 'linear-gradient(135deg, #5B3DF5 0%, #3D76F5 100%)'
  },
  spacing: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '3rem',
    xxl: '5rem'
  }
};

export default theme; 